import type { SubmissionParams } from "./Payment";
import { DetailsStep } from "./Navigation";

export enum EventName {
  INIT = "donation:init",
  SELECT_AMOUNT = "donation:select-amount",
  FORM_SUBMIT = "donation:form-submit",
  PURCHASE = "donation:purchase-success",
  PURCHASE_ERROR = "donation:purchase-error",
  STEP_CHANGE = "donation:step-change",
  STEP_SUBMIT = "donation:step-submit",
}

export type EventMap = {
  [EventName.INIT]: undefined;
  [EventName.SELECT_AMOUNT]: {
    amount: number;
    currency: string;
    donation_type: string;
    accepted_default: boolean;
  };
  [EventName.FORM_SUBMIT]: SubmissionParams;
  [EventName.PURCHASE]: unknown;
  [EventName.PURCHASE_ERROR]: unknown;
  [EventName.STEP_CHANGE]: { step_name: DetailsStep };
  [EventName.STEP_SUBMIT]:
    | DefaultStepData
    | CardSelectorStepData
    | DonationInformationStepData
    | PaymentTypeStepData
    | PersonalDetailsStepData;
};

type DefaultStepData = {
  step_name: Exclude<
    DetailsStep,
    | DetailsStep.SelectCard
    | DetailsStep.DonationInformation
    | DetailsStep.PaymentType
  >;
  data: Record<string, unknown>;
};

type CardSelectorStepData = {
  step_name: DetailsStep.SelectCard;
  data: {
    card_type: string;
    celebration_type: string;
    honouring_forename: string;
    honouring_surname: string;
  };
};

type DonationInformationStepData = {
  step_name: DetailsStep.DonationInformation;
  data: {
    uk_taxpayer: boolean | null;
    sign_up_frontline: boolean;
    on_behalf: string;
    organisation_name: string;
  };
};

type PaymentTypeStepData = {
  step_name: DetailsStep.PaymentType;
  data: {
    payment_method: string;
  };
};

type PersonalDetailsStepData = {
  step_name: DetailsStep.YourDetails;
  data: {
    forename: string;
    surname: string;
    email: string;
  };
};
